import { SagaIterator } from 'redux-saga';
import { all } from 'redux-saga/effects';
import { ClientReducer } from '@bcp-nextgen-dx-touchpoint-framework/react-js';
import { baseReducer, BaseState } from './base';
import { servicesReducer, ServicesState } from './services';
import { userInputReducer, UserInputState } from './userInput';
import { NavigationState, navigationReducer } from './navigation';
import { TempDataState, tempDataReducer } from './tempData';

export interface AppState {
	baseState: BaseState;
	servicesState: ServicesState;
	userInputState: UserInputState;
	navigationState: NavigationState;
	tempDataState: TempDataState;
}

export const rootReducer: ClientReducer<AppState> = {
	baseState: {
		reducer: baseReducer,
	},
	servicesState: {
		reducer: servicesReducer,
	},
	userInputState: {
		reducer: userInputReducer,
	},
	navigationState: {
		reducer: navigationReducer,
	},
	tempDataState: {
		reducer: tempDataReducer,
	},
};

export function* rootSaga(): SagaIterator {
	yield all([]);
}
